import React from 'react';
import { Icon } from './Icon.js';
export const IconCircles5Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("circle", { cx: "9", cy: "9", r: "5", fill: "currentColor" }),
        React.createElement("circle", { cx: "3.25", cy: "3.25", r: "1.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "14.75", cy: "3.25", r: "1.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "3.25", cy: "14.75", r: "1.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "14.75", cy: "14.75", r: "1.25", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconCircles5Fill18.js.map